import { CreateProductGroup, ProductGroupFormValues } from "../productGroupTypes"
import { DateTimeFactory } from "../../../../localization/useDateTime"

export const prepareProductGroup = (
    values: ProductGroupFormValues,
    dateTimeFactory: DateTimeFactory,
): CreateProductGroup => {
    const {
        name,
        isActive,
        productGroupCode,
        priceList,
        // priceLists,
        weekDays,
        timeIntervalStart,
        timeIntervalEnd,
        isLocked,
        availableTime,
    } = values

    const productGroupCodeBody = productGroupCode
        ? {
              productGroupCode: {
                  id: productGroupCode.id,
              },
          }
        : {}

    return {
        name,
        isActive,
        ...productGroupCodeBody,
        // priceLists: priceLists.map((pl) => ({ id: pl.id })),
        priceLists: priceList ? [{ id: priceList.id }] : [],
        securitySettings: {
            isLocked,
        },
        ...(availableTime
            ? {
                  availabilityDetails: {
                      weekDays,
                      timeInterval: {
                          start: dateTimeFactory.formatTime(timeIntervalStart),
                          end: dateTimeFactory.formatTime(timeIntervalEnd),
                      },
                  },
              }
            : {}),
    }
}
